import {
  BlockModel,
  BlockSchemaExtension,
  defineBlockSchema,
  type Text,
} from '@blocksuite/store';

import type { BlockMeta } from '../../utils/types';

type CodeBlockProps = {
  text: Text;
  language: string | null;
  wrap: boolean;
  caption: string;
} & BlockMeta;

export const CodeBlockSchema = defineBlockSchema({
  flavour: 'hive:code',
  props: internal =>
    ({
      text: internal.Text(),
      language: null,
      wrap: false,
      caption: '',
      'meta:createdAt': undefined,
      'meta:createdBy': undefined,
      'meta:updatedAt': undefined,
      'meta:updatedBy': undefined,
    }) as CodeBlockProps,
  metadata: {
    version: 1,
    role: 'content',
    parent: [
      'hive:note',
      'hive:paragraph',
      'hive:list',
      'hive:edgeless-text',
    ],
    children: [],
  },
  toModel: () => new CodeBlockModel(),
});

export const CodeBlockSchemaExtension = BlockSchemaExtension(CodeBlockSchema);

export class CodeBlockModel extends BlockModel<CodeBlockProps> {}
